module.exports = __webpack_public_path__ + "20735618037401631f62863a31d3dce7.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/perks/sofas/sofa-gamer.png
// module id = 3426
// module chunks = 0